export default __webpack_public_path__ + "static/media/analytics-selected.46d5180f.svg";